export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7892.fd4d05f2.jpg";